import {IntlProvider} from 'react-intl';
import {registerValidation} from './validation';
import {Locales} from '../constants/enums'

let _intl;

const DEFAULT_LOCALE = Locales.English;

export const messages = {
    [Locales.English]: require('../translations/en-US.json'),
    [Locales.Spanish]: require('../translations/es-ES.json'),
    [Locales.Hebrew]: require('../translations/he-IL.json'),
    [Locales.Italian]: require('../translations/it-IT.json'),
    [Locales.German]: require('../translations/de-DE.json')

};

export function setIntlProvider(locale) {
    const intlProvider = new IntlProvider({locale: locale, messages: Object.assign({}, messages[DEFAULT_LOCALE], messages[locale])}); // both locale and messages are in the app state
    const {intl} = intlProvider.getChildContext();
    _intl = intl;
    registerValidation();
}

export function getLocaleMessages(locale) {
    const res = Object.assign({}, messages[DEFAULT_LOCALE], messages[locale]);

    /*
    //Util method to download locale json file
    let filename = "export.json";
    let contentType = "application/json;charset=utf-8;";
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(res)))], { type: contentType });
        navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        const a = document.createElement('a');
        a.download = filename;
        a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(res));
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        //https://codeshack.io/json-sorter/
    }*/
    return res;
}

export function translate (id, values) {
    return _intl.formatMessage({id:id}, values);
}

export async function getLocation() {
    const result1 = await fetch('https://ip-location.icu/api/v1/user-info/?apiKey=5J6VXb6dcPHJ1dVqy4tqEfBNWIlvW2tTIjnC0dQq');
    const json1 = await result1.json();
    const result2 = await fetch('https://ip-location.icu/api/v1/city/?apiKey=5J6VXb6dcPHJ1dVqy4tqEfBNWIlvW2tTIjnC0dQq&ip=' + json1.ip);
    return result2.json();
}
